import { render, staticRenderFns } from "./AntiaddictionTest.vue?vue&type=template&id=17f8b31a&scoped=true&"
import script from "./AntiaddictionTest.vue?vue&type=script&lang=js&"
export * from "./AntiaddictionTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f8b31a",
  null
  
)

export default component.exports